var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateBorderMiddleGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1600.2 349.2",
    style: {
      enableBackground: "new 0 0 1600.2 349.2"
    },
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6;fill:#A37400;enable-background:new    ;}\n\t.st1{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1527.4,-123.5 1546.7,-143.5 1566.1,-123.5 1566.1,472.3 1546.7,492.3 1527.4,472.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "73,472.6 53.6,492.6 34.3,472.6 34.3,-123.2 53.6,-143.2 73,-123.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1546.7,-143.5 1527.4,-123.5 1527.4,472.3 1546.7,492.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.6,492.6 73,472.6 73,-123.2 53.6,-143.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateBorderMiddleGold);
export default __webpack_public_path__ + "static/media/certificate-border-middle-gold.be81af6ed4463eee3cdf1da31f614e77.svg";
export { ForwardRef as ReactComponent };